export default {
    title: 'Mapa Astral Grátis',
    subtitle: 'Descubra os signos do seu mapa e inicie uma jornada de autoconhecimento com a Astrologia.'
}